'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogColor = function DialogColor() {
    (0, _classCallCheck3.default)(this, DialogColor);
};

DialogColor.GREEN = 'green';
DialogColor.RED = 'red';
DialogColor.ORANGE = 'orange';
DialogColor.PURPLE = 'purple';
DialogColor.DARK = 'dark';
DialogColor.BLUE = 'blue';
DialogColor.PRIMARY = 'primary';
DialogColor.DEFAULT = 'default';
exports.default = DialogColor;


// WEBPACK FOOTER //
// ./client/app/common/models/dialog/dialogColor.js